import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tab, Nav } from 'react-bootstrap'; //  Col

import { titleCase } from '../../utils/changeCase';
import { format as stringFormat } from 'react-string-format';
import { userGroupUrlCheck } from '../../utils/userGroupUrlCheck';

import { ROUTE_REFRESH, LOGIN_AFFILIATE_GROUP, LOGIN_SUPER_ADMIN_GROUP, LOGIN_CLIENT_GROUP, LOGIN_CREW_GROUP, ROUTE_DYNAMIC_FIELDS_CREW, ROUTE_DYNAMIC_FIELDS_CLIENTS, ROUTE_DYNAMIC_FIELDS_AFFILIATES, DYNAMIC_PAGE_ICONS, DYNAMIC_FIELDS_TYPES, DELETE_SYMBOL, ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS, ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW, ROUTE_SA_SETTINGS, ROUTE_AFFILIATE_SETTINGS } from '../../configs/staticConfigs'; // , LOGIN_OMNU_AFFILIATE_GROUP
import { MSG_ERROR, MSG_DYNAMIC_FIELD_NAME_REQUIRED, MSG_DYNAMIC_FIELD_TYPE_REQUIRED, MSG_DYNAMIC_FIELD_TYPE_UPDATE_SUCCESS, MSG_DYNAMIC_FIELD_TYPE_UPDATE_ERROR, MSG_DYN_FIELD_DUPLICATE_ENTRY, MSG_CONFIRM_DATA_CHANGE_DYNAMIC, MSG_NOT_FOUND } from '../../configs/msgConfigs'; // , MSG_REQUIRED 

import { LBL_SECTIONS, LBL_CREW_SECTIONS, LBL_CLIENT_SECTIONS, LBL_CREW_VISIBILITY, LBL_CLIENT_VISIBILITY, LBL_APP_NAME, LBL_SETTINGS, LBL_FIELD_NAME, LBL_FIELD_TYPE, LBL_AFFILIATES, LBL_CLIENTS, LBL_CREW, LBL_DYNAMIC, LBL_FIELDS, LBL_CLIENT_CATEGORIES, LBL_BTN_ADDNEW, LBL_SHOW_THIS_TAB, LBL_MANDATORY_FIELD, LBL_SLNUM, LBL_SAVE, LBL_CATEGORIES, LBL_CREW_CATEGORIES, LBL_CONFIRM_DATA_CHANGE, LBL_CONFIRM_DELETE, LBL_ARE_YOU_SURE_DELETE_COMMON, LBL_FOR_AFFILIATES, LBL_FOR_CLIENTS, LBL_FOR_CREW, LBL_BACK_TO_SETTINGS, LBL_ADD_FIELDS, LBL_SELECT } from '../../configs/labelConfigs'; // LBL_FIELD_MANDATORY

import { dynamicFieldsListAction, dynamicFieldsUpdateAction, dynamicFieldsMasterListAction } from '../../actions/settings/dynamicFieldsActions';
import { clearAction } from '../../actions/commonActions';
import { DYNAMIC_FIELDS_LIST_SUCCESS, DYNAMIC_FIELDS_LIST_ERROR, DYNAMIC_FIELDS_UPDATE_SUCCESS, DYNAMIC_FIELDS_UPDATE_ERROR, DYNAMIC_FIELDS_MASTER_LIST_SUCCESS, DYNAMIC_FIELDS_MASTER_LIST_ERROR } from '../../actions';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

class DynamicFieldsComponent extends Component {

    constructor(props) {
        super(props)

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        let userProfileId = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            userProfileId = userGroupData.profile_id;
        }

        this.state = {
            leftPanelItems: {},
            dynFieldsAllItems: [],
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },
            activePageId: 0,
            deleteRowIndexNum: 0,
            formErrors: {
                fieldEmpty: ''
            },
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            formClick: false,
            listData: { groupId: 0, reqFrom: 0 },
            userGroup: userGroup,
            userProfileId: userProfileId,
            deleteFieldName: '',
            headerText: '',
            commonErrMsg: '',
            dynamicFieldName: '',
            refPageId: 0,
            refName: '',
            dynFieldMasterItems: [],
            addNewFieldIds: [],
            addNewFieldsObj: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' }, 
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData = this.saveFormData.bind(this);
        this.changePage = this.changePage.bind(this);
        this.addNewRow = this.addNewRow.bind(this);
        this.removeRow = this.removeRow.bind(this);
        this.checkFormData = this.checkFormData.bind(this);

        this.modalConfirm = React.createRef();
        this.modalDelete = React.createRef();
        this.modalAdd = React.createRef();
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            this.setState({ userGroup: userGroup });
        }
        if (userGroup === LOGIN_AFFILIATE_GROUP) {
            document.body.classList.add('body-affiliate');
        }

        let groupId = 0;
        let uType = '';
        if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_AFFILIATES) {
            uType = LBL_FOR_AFFILIATES;
            groupId = LOGIN_AFFILIATE_GROUP;
        }
        else if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_CLIENTS || this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS) {
            uType = LBL_FOR_CLIENTS;
            groupId = LOGIN_CLIENT_GROUP;
        }
        else if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_CREW || this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW) {
            uType = LBL_FOR_CREW;
            groupId = LOGIN_CREW_GROUP;
        }

        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " - " + LBL_DYNAMIC + ' ' + LBL_FIELDS + ' ' + uType;

        let listData = { groupId: groupId, reqFrom: userGroup };
        this.setState({ listData: listData });
        this.props.dynamicFieldsListAction(listData); //groupId 
    }

    saveData = () => {
        this.modalConfirm.current.handleModelCloseOnly();
        this.saveFormData('');
    }

    changePage = (event, refPageId, refName) => {
        if (this.state.formClick === true) {
            this.modalConfirm.current.handleOpenModal();
            this.setState({ formClick: false, refPageId: refPageId, refName: refName });
        }
        else if (this.state.activePageId !== refPageId) {
            let allPagesFieldsObj = [];
            let newActiveObj = {};
            this.state.dynFieldsAllItems.forEach((item, index) => {
                if (item.id === this.state.activePageId) allPagesFieldsObj.push(this.state.dynFieldsActiveItem);
                else allPagesFieldsObj.push(item);
                if (item.id === refPageId) {
                    newActiveObj = item;
                }
            });
            this.setState({ activePageId: refPageId, dynFieldsActiveItem: newActiveObj, dynFieldsAllItems: allPagesFieldsObj, toastFlag: false, toastMessage: '', toastSuccess: true, headerText: titleCase(refName), dynamicFieldName: refName, refPageId: 0, refName: '' });
        }
    }

    onHandleChange = (e, fieldIndex, fieldName) => {
        // this.setState({formClick:true}); // to track form update without any value change in component did update // field_name field_type is_mandatory value 
        const valStr = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        let formErrors = this.state.formErrors;
        let activeData = this.state.dynFieldsActiveItem;

        if (fieldName === 'show_tab') {
            activeData.show_tab = valStr; // (activeData.field_details[fieldIndex].is_mandatory) ? false : true;
            this.setState({ formClick: true, dynFieldsActiveItem: activeData });
        }
        else if (fieldName === 'field_name') {
            formErrors.fieldEmpty = '';
            if (valStr === '') formErrors.fieldEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED;
            activeData.field_details[fieldIndex].field_name = valStr;
            this.setState({ formClick: true, dynFieldsActiveItem: activeData, formErrors: formErrors, commonErrMsg: '' });
        }
        else if (fieldName === 'field_type') {
            formErrors.fieldEmpty = '';
            if (valStr === '') formErrors.fieldEmpty = MSG_DYNAMIC_FIELD_TYPE_REQUIRED;
            activeData.field_details[fieldIndex].field_type = valStr;
            this.setState({ formClick: true, dynFieldsActiveItem: activeData, formErrors: formErrors });
        }
        else if (fieldName === 'is_mandatory') {
            activeData.field_details[fieldIndex].is_mandatory = valStr; // (activeData.field_details[fieldIndex].is_mandatory) ? false : true;
            this.setState({ formClick: true, dynFieldsActiveItem: activeData });
        }
        else if (fieldName === 'crew_visibility') {
            activeData.field_details[fieldIndex].crew_visibility = valStr; // (activeData.field_details[fieldIndex].is_mandatory) ? false : true;
            this.setState({ formClick: true, dynFieldsActiveItem: activeData });
        }
        else if (fieldName === 'client_visibility') {
            activeData.field_details[fieldIndex].client_visibility = valStr; // (activeData.field_details[fieldIndex].is_mandatory) ? false : true;
            this.setState({ formClick: true, dynFieldsActiveItem: activeData });
        }
    }

    addNewRow = (e) => {
        if (this.state.userGroup === LOGIN_AFFILIATE_GROUP) {
            let groupId = this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS ? LOGIN_CLIENT_GROUP : this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW ? LOGIN_CREW_GROUP : 0;

            let listData = { groupId: groupId, reqFrom: this.state.userGroup };
            this.props.dynamicFieldsMasterListAction(listData);
            this.setState({formClick: true, addNewFieldIds:[]}); 
        }
        else {
            let newfieldObj = this.state.dynFieldsActiveItem.field_details;
            if (this.state.dynamicFieldName === 'Vehicle Info') {
                newfieldObj.push({ field_id: Date.now(), field_name: '', field_type: '', is_mandatory: false, value: '', crew_visibility: false, client_visibility: false });
            } else {
                newfieldObj.push({ field_id: Date.now(), field_name: '', field_type: '', is_mandatory: false, value: '' });
            }
            // id name field_details show_tab icon_name user_type
            let newActiveObj = this.state.dynFieldsActiveItem;
            newActiveObj.field_details = newfieldObj;

            let allPagesFieldsObj = [];
            this.state.dynFieldsAllItems.forEach((item, index) => {
                if (item.id === this.state.activePageId) allPagesFieldsObj.push(newActiveObj);
                else allPagesFieldsObj.push(item);
            });

            this.setState({ formClick: true, dynFieldsActiveItem: newActiveObj, dynFieldsAllItems: allPagesFieldsObj });
        }

    }

    removeRow = (fieldIndex) => {
        let newfieldObj = [];
        this.state.dynFieldsActiveItem.field_details.forEach((item, index) => {
            if (index !== fieldIndex) newfieldObj.push(item);
        });
        // id name field_details show_tab icon_name user_type
        let newActiveObj = this.state.dynFieldsActiveItem;
        newActiveObj.field_details = newfieldObj;

        let allPagesFieldsObj = [];
        this.state.dynFieldsAllItems.forEach((item, index) => {
            if (item.id === this.state.activePageId) allPagesFieldsObj.push(newActiveObj);
            else allPagesFieldsObj.push(item);
        });

        this.setState({ formClick: true, dynFieldsActiveItem: newActiveObj, dynFieldsAllItems: allPagesFieldsObj });
    }

    onCloseToast = () => {
        this.setState({ toastFlag: false, toastMessage: '', toastSuccess: true });
    }

    onModalFormAddReset = () => {

    }

    onModalFormReset = () => {
        this.setState({ deleteRowIndexNum: 0, deleteFieldName: '' });
        if (this.state.refPageId > 0) {
            this.changePage('', this.state.refPageId, this.state.refName);
        }
    }

    onModalFormConfirmReset = () => {
        this.setState({ deleteRowIndexNum: 0, deleteFieldName: '', formClick: false });
        this.props.dynamicFieldsListAction(this.state.listData);
        // if(this.state.refPageId > 0) {
        //     this.changePage('',this.state.refPageId,this.state.refName); 
        // }
    }

    deleteBtnClick = (indexNum, itemName, fieldValue) => {
        if (fieldValue !== '') {
            this.setState({ formClick: true, commonErrMsg: '', deleteRowIndexNum: indexNum, deleteFieldName: itemName }, () => this.modalDelete.current.handleOpenModal());
        }
        else {
            this.setState({ formClick: true, commonErrMsg: '', deleteRowIndexNum: indexNum, deleteFieldName: itemName }, () => this.removeRow(this.state.deleteRowIndexNum))
        }
    }

    onDeleteAction = () => {
        if (this.state.deleteRowIndexNum >= 0) this.removeRow(this.state.deleteRowIndexNum);
        this.modalDelete.current.handleModelClose();
    }

    checkFormData() {
        let arrDuplicateCheck = [];
        let objTmp = {};
        let foundError = 0;
        let errMsg = this.state.formErrors;
        this.state.dynFieldsActiveItem.field_details.forEach((item, index) => {
            // field_id field_name field_type is_mandatory value
            if (item.field_name.trim() === '') {  // checkNumDot,
                foundError = 1;
                errMsg.fieldEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED;
                this.setState({ formErrors: errMsg });
                return false;
            }
            else if (item.field_type.trim() === '') {
                foundError = 1;
                errMsg.fieldEmpty = MSG_DYNAMIC_FIELD_TYPE_REQUIRED;
                this.setState({ formErrors: errMsg });
                return false;
            }
            else {
                if (arrDuplicateCheck.includes(item.field_name)) {
                    foundError = 1;
                    this.setState({ commonErrMsg: MSG_DYN_FIELD_DUPLICATE_ENTRY + ' - ' + item.field_name });
                    return false;
                }
                else {
                    arrDuplicateCheck.push(item.field_name);
                }
            }
        });
        if (foundError === 0) {
            return true;
        }
    }

    onSelectAddnewCheckbox = (e,itemId) => {
        let arrTemp = this.state.addNewFieldIds; 
        if(e.target.checked) {
            if(!arrTemp.includes(itemId)) {
                arrTemp.push(itemId); 
                this.setState({addNewFieldIds:arrTemp})
            }
        }
        else {
            const index = arrTemp.indexOf(itemId);
            if (index > -1) { 
                arrTemp.splice(index, 1); 
            }
            this.setState({ addNewFieldIds: arrTemp });
        }
    }

    onAddFieldDetailsRows = () => {
        if(this.state.addNewFieldIds && this.state.addNewFieldIds.length > 0) { 
            let newDynFieldsActiveItem = this.state.dynFieldsActiveItem;
            let newFieldDetailsObj = newDynFieldsActiveItem.field_details; 
            
            let newFieldObj = {}
            this.state.addNewFieldIds.forEach(fId => {
                newFieldObj = this.state.addNewFieldsObj.field_details.find(fItem => fItem.field_id==fId); 
                if(!newFieldDetailsObj.find(fActiveItem => fActiveItem.field_id==fId)) {
                    newFieldDetailsObj.push(newFieldObj);  
                }
                newFieldObj = {}; 
            });
            newDynFieldsActiveItem.field_details = newFieldDetailsObj; 
            this.setState({dynFieldsActiveItem:newDynFieldsActiveItem, addNewFieldIds:[]}); 
            this.modalAdd.current.handleModelCloseOnly();
        }
    }

    saveFormData = (e) => {
        if (e) e.preventDefault();
        this.setState({ commonErrMsg: '', formClick: true });
        if (this.state.userGroup === LOGIN_AFFILIATE_GROUP) {
            let activeDataItemObj = this.state.dynFieldsActiveItem; 
            // INSERT master_id IN dynFieldsActiveItem OBJECT, IF NOT EXISTS 
            if(!this.state.dynFieldsActiveItem.master_id && this.state.dynFieldMasterItems.length > 0) {
                let masterFieldsObj = this.state.dynFieldMasterItems.find(item => item.name==activeDataItemObj.name);  
                activeDataItemObj = {...activeDataItemObj, master_id: masterFieldsObj.id}; 
            } 
            let saveDataObj = { affiliate: this.state.userProfileId, reqFrom: this.state.listData.reqFrom, ...activeDataItemObj };
            this.props.dynamicFieldsUpdateAction(saveDataObj);
        }
        else {
            if (this.checkFormData()) {
                // {id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' } 
                let saveDataObj = {};
                if (this.state.userGroup === LOGIN_AFFILIATE_GROUP) {
                    saveDataObj = { affiliate: this.state.userProfileId, reqFrom: this.state.listData.reqFrom, ...this.state.dynFieldsActiveItem };
                }
                else {
                    saveDataObj = { reqFrom: this.state.listData.reqFrom, ...this.state.dynFieldsActiveItem };
                }
                this.props.dynamicFieldsUpdateAction(saveDataObj);
            }
        }
    }

    getFieldCode = (fType) => {
        let fObj = DYNAMIC_FIELDS_TYPES.find((item, selIndex) => item.value == fType)
        return (fObj?.code ? fObj.code : '')
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            let userGroupData = userGroupUrlCheck(this.props.location);
            let userGroup = '';
            if (userGroupData !== undefined) {
                userGroup = userGroupData.user_group;
            }
            let groupId = 0;
            let uType = '';
            if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_AFFILIATES) {
                uType = LBL_FOR_AFFILIATES;
                groupId = LOGIN_AFFILIATE_GROUP;
            }
            else if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_CLIENTS || this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS) {
                uType = LBL_FOR_CLIENTS;
                groupId = LOGIN_CLIENT_GROUP;
            }
            else if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_CREW || this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW) {
                uType = LBL_FOR_CREW;
                groupId = LOGIN_CREW_GROUP;
            }
            document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " - " + LBL_DYNAMIC + ' ' + LBL_FIELDS + ' ' + uType;

            let listData = { groupId: groupId, reqFrom: userGroup };
            this.setState({ listData: listData });
            this.props.dynamicFieldsListAction(listData);  //groupId 
        }

        const { status, activity, errorData, dynFieldMasterItems, dynFieldMasterStatus, dynFieldMasterActivity } = this.props;

        if (dynFieldMasterActivity && (dynFieldMasterStatus !== prevProps.dynFieldMasterStatus || dynFieldMasterActivity !== prevProps.dynFieldMasterActivity)) {
            if (dynFieldMasterStatus !== 401) {
                var arrTmpResp = dynFieldMasterActivity.split('~~');
                var tmpString = arrTmpResp[0];
                if (tmpString === DYNAMIC_FIELDS_MASTER_LIST_SUCCESS) {
                    if (this.props.hasOwnProperty('dynFieldMasterItems')) {
                        if (this.props.dynFieldMasterItems.length === 0) {
                            this.setState({ dynFieldMasterItems: [] });
                        }
                        else {
                            let addNewFieldsObj = this.props.dynFieldMasterItems.find(item => item.name==this.state.dynFieldsActiveItem.name);   
                            let fDet = []; 
                            if(addNewFieldsObj && addNewFieldsObj.field_details) {
                                addNewFieldsObj.field_details.forEach(item =>  {
                                    if(!this.state.dynFieldsActiveItem.field_details.find(fItem => fItem.field_name==item.field_name)) {
                                        fDet.push(item);  
                                    }
                                })
                                addNewFieldsObj = {...addNewFieldsObj, field_details:fDet}; 
                            }
                            
                            
                            this.setState({ dynFieldMasterItems: this.props.dynFieldMasterItems, addNewFieldsObj:addNewFieldsObj });
                        }
                    }
                    else {
                        this.setState({ dynFieldsAllItems: [] });
                    }
                    this.modalAdd.current.handleOpenModal();
                }
                else if (actString === DYNAMIC_FIELDS_LIST_ERROR) {
                    let toastErrMsg = MSG_ERROR + ' ' + JSON.stringify(errorData);
                    this.setState({ toastSuccess: false, toastFlag: true, toastMessage: toastErrMsg });
                    setTimeout(() => {
                        this.onCloseToast();
                    }, 3000);
                }
            }
        }


        if (activity && (status !== prevProps.status || activity !== prevProps.activity)) {
            if (status !== 401) {
                var arrResp = activity.split('~~');
                var actString = arrResp[0];
                if (actString === DYNAMIC_FIELDS_LIST_SUCCESS) {
                    if (this.props.hasOwnProperty('dynFieldsAllItems')) {
                        if (this.props.dynFieldsAllItems.length === 0) {
                            this.setState({ dynFieldsAllItems: [] });
                        }
                        else {
                            let tmpObj = {};
                            let fieldsObj = {};
                            let firstObj = {};
                            let firstPageId = 0;
                            let headerText = '';
                            let dynamicFieldName = '';
                            // {"id":3,"name":"Bank Details","field_details":[],"show_tab":true,"icon_name":null,"user_type":4}  
                            let cnt = 0;
                            let allPagesObj = [];
                            this.props.dynFieldsAllItems.forEach((rObj) => {
                                cnt++;
                                if (!Array.isArray(rObj.field_details)) rObj.field_details = []; // IF OBJECT {} RETURNED, CONVERT TO ARRAY 
                                if (rObj.field_details.length === 0) {
                                    fieldsObj = []; 
                                    // fieldsObj = [
                                    //     { field_id: Date.now(), field_name: '', field_type: '', is_mandatory: false, value: '' }
                                    // ];
                                }
                                else {
                                    fieldsObj = rObj.field_details;
                                }

                                let iconName = '';
                                if (!rObj.icon_name || rObj.icon_name === null || (rObj.hasOwnProperty('icon_name') && rObj.icon_name.trim().length === 0)) {
                                    let filterObj = { pageName: '', iconName: '' };
                                    filterObj = DYNAMIC_PAGE_ICONS.filter(pageDet => pageDet.pageName.trim().toLowerCase() === rObj.name.trim().toLowerCase());
                                    if (filterObj.length) iconName = filterObj[0].iconName;
                                }
                                else {
                                    iconName = rObj.icon_name;
                                }

                                tmpObj = {
                                    id: rObj.id, name: rObj.name, field_details: fieldsObj, show_tab: rObj.show_tab, icon_name: iconName, user_type: rObj.user_type
                                };

                                if (cnt === 1) {
                                    firstObj = tmpObj;
                                    firstPageId = rObj.id;
                                    headerText = rObj.name;
                                    dynamicFieldName = rObj.name;
                                }
                                allPagesObj.push(tmpObj);
                            });
                            this.setState({ activePageId: firstPageId, dynFieldsActiveItem: firstObj, dynFieldsAllItems: allPagesObj, headerText: titleCase(headerText), dynamicFieldName: dynamicFieldName }, () => {
                                if (this.state.refPageId > 0) {
                                    this.changePage('', this.state.refPageId, this.state.refName);
                                }
                            }
                            );
                        }
                    }
                    else {
                        this.setState({ dynFieldsAllItems: [] });
                    }
                }
                else if (actString === DYNAMIC_FIELDS_LIST_ERROR) {
                    let toastErrMsg = MSG_ERROR + ' ' + JSON.stringify(errorData);
                    this.setState({ toastSuccess: false, toastFlag: true, toastMessage: toastErrMsg });
                    setTimeout(() => {
                        this.onCloseToast();
                    }, 3000);
                }
                else if (actString === DYNAMIC_FIELDS_UPDATE_SUCCESS) {
                    this.setState({ toastSuccess: true, toastFlag: true, toastMessage: MSG_DYNAMIC_FIELD_TYPE_UPDATE_SUCCESS, formClick: false }, () => {
                        if (this.state.refPageId > 0) {
                            this.changePage('', this.state.refPageId, this.state.refName);
                        }
                    });
                    setTimeout(() => {
                        this.onCloseToast();
                    }, 4000);

                }
                else if (actString === DYNAMIC_FIELDS_UPDATE_ERROR) {
                    let toastErrMsg = MSG_DYNAMIC_FIELD_TYPE_UPDATE_ERROR + ' ' + JSON.stringify(errorData);
                    this.setState({ toastSuccess: false, toastFlag: true, toastMessage: toastErrMsg });
                    setTimeout(() => {
                        this.onCloseToast();
                    }, 5000);
                }
            }
        }
    }


    render() {

        const { status } = this.props;
        const { toastMessage, toastFlag, toastSuccess, dynFieldsActiveItem, addNewFieldsObj } = this.state;

        if (status === 401 || status === 403) {
            return <Redirect to={ROUTE_REFRESH} />;
        }
        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrew = 'Staff'
        if (userGroupData !== undefined) {
            if (userGroupData.staff_name) {
                lblCrew = userGroupData.staff_name;
            }
        }

        let categoriesHeading = LBL_SECTIONS;

        if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_CLIENTS || this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS) {
            categoriesHeading = LBL_CLIENT_SECTIONS;
        }
        else if (this.props.location.pathname === ROUTE_DYNAMIC_FIELDS_CREW || this.props.location.pathname === ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW) {
            categoriesHeading = stringFormat(LBL_CREW_SECTIONS, lblCrew);
        }

        return (
            <React.Fragment>

                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <Tab.Container id="dynamicField-tab" defaultActiveKey="dynamicField-details-tab">
                    <div className='col-12 divFloatLeft padding-left-20 padding-Bottom-5 font-14'><Link to={this.state.userGroup === LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_SETTINGS : ROUTE_SA_SETTINGS}>{ LBL_BACK_TO_SETTINGS }</Link> </div>
                    <div className="col-md-4 col-lg-3 col-xl-2 col-12">
                        <div className="box">
                            <div className="tab-head">
                                <div className="text-bold normalText leftPanelHeading ">{categoriesHeading}</div>
                            </div>
                        </div>

                        <Nav variant="pills" className="nav flex-column nav-pills box">
                            {this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item, index) => {
                                if (this.state.activePageId === item.id && this.state.userGroup === LOGIN_SUPER_ADMIN_GROUP) return (<Nav.Link eventKey="dynamicField-details-tab" key={index} className="active" ><i className={item.icon_name}></i> {item.name}</Nav.Link>
                                );
                                else if (this.state.activePageId === item.id) return (<Nav.Link eventKey="dynamicField-details-tab" key={index} className='active' ><i className={item.icon_name}></i> <small>{item.name}</small></Nav.Link>
                                );
                                else return (<Nav.Link key={index} onClick={(e) => this.state.activePageId !== item.id ? this.changePage(e, item.id, item.name) : ''} ><i className={item.icon_name}></i> <small>{item.name}</small></Nav.Link>
                                )
                            })}
                        </Nav>
                    </div>
                    <div className="col-md-4 col-lg-6 col-xl-7 col-9 pl-0">
                        <Tab.Content>
                            <Tab.Pane eventKey="dynamicField-details-tab">
                                <div className="box">
                                    <div className="tab-head tdVeticalMiddle">
                                        {/* headerAddNewButtonPadding */}
                                        <div className="float-left tdVeticalMiddle btn marginLeft0"><h6>{this.state.headerText}</h6></div>
                                        <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow(e)} >{LBL_BTN_ADDNEW}</button></div>
                                    </div>
                                    <div className="box-content">
                                        <div className="table-responsive">
                                            {this.state.hasOwnProperty('dynFieldsActiveItem') &&
                                                <table id="data-table" className='table dynTable'  >
                                                    <thead className="text-bold">
                                                        <tr>
                                                            <th className="text-center ">{LBL_SLNUM}</th>
                                                            <th className="text-center ">{LBL_FIELD_NAME}</th>
                                                            <th className="text-center ">{LBL_FIELD_TYPE}</th>
                                                            {/* {this.state.dynamicFieldName === 'Vehicle Info' && <th className="text-center ">{stringFormat(LBL_CREW_VISIBILITY, lblCrew)}</th>}
                                                            {this.state.dynamicFieldName === 'Vehicle Info' && <th className="text-center ">{LBL_CLIENT_VISIBILITY}</th>} */}
                                                            <th className="text-center ">{LBL_MANDATORY_FIELD}</th>
                                                            <th className="text-center "></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!dynFieldsActiveItem.field_details || dynFieldsActiveItem.field_details.length==0 && 
                                                            <tr>
                                                                <td colSpan="7" className="text-center">{MSG_NOT_FOUND}</td>
                                                            </tr>
                                                        }
                                                        {dynFieldsActiveItem.field_details.map((fieldObj, fieldIndex) => {
                                                            return (
                                                                <tr key={fieldObj.field_id}>

                                                                    <td className="text-center">{fieldIndex + 1}</td>

                                                                    {this.state.userGroup === LOGIN_AFFILIATE_GROUP && <><td className="tdVeticalMiddle">
                                                                        <div>{this.state.dynFieldsActiveItem.field_details[fieldIndex].field_name}</div> </td>
                                                                        <td className="text-center">{this.getFieldCode(this.state.dynFieldsActiveItem.field_details[fieldIndex].field_type)}
                                                                        </td>
                                                                        <td className="text-center">{this.state.dynFieldsActiveItem.field_details[fieldIndex].is_mandatory ? 'Y' : 'N'}
                                                                        </td>
                                                                        <td className="text-center"><i className={DELETE_SYMBOL} title='Remove this Row' onMouseDown={(e) => this.deleteBtnClick(fieldIndex, (LBL_FIELD_NAME.toLowerCase() + ' "' + dynFieldsActiveItem.field_details[fieldIndex].field_name + '"'), this.state.dynFieldsActiveItem.field_details[fieldIndex].field_name.trim())} ></i>&nbsp;</td>
                                                                    </>
                                                                    }

                                                                    {this.state.userGroup === LOGIN_SUPER_ADMIN_GROUP && <><td><div className="form-group text-input tdVeticalMiddle">
                                                                        <input name={"txt_fieldName_" + fieldObj.field_id} value={this.state.dynFieldsActiveItem.field_details[fieldIndex].field_name} onChange={(e) => this.onHandleChange(e, fieldIndex, 'field_name')} maxLength={120} className={this.state.dynFieldsActiveItem.field_details[fieldIndex].field_name.trim() === '' ? "input-error" : ''} />
                                                                    </div></td>
                                                                        <td className="text-center">
                                                                            <div className="form-group select-input">
                                                                                <select name={"sel_fieldType_" + fieldObj.field_id} onChange={(e) => this.onHandleChange(e, fieldIndex, 'field_type')} value={this.state.dynFieldsActiveItem.field_details[fieldIndex].field_type} className={this.state.dynFieldsActiveItem.field_details[fieldIndex].field_type.trim() === '' ? "input-error" : ''} >
                                                                                    <option key={fieldObj.field_id + '_' + fieldIndex + '_0'} value=''>Select</option>
                                                                                    {DYNAMIC_FIELDS_TYPES.map((item, selIndex) => <option key={fieldObj.field_id + '_' + selIndex} value={item.value}>{item.code}</option>)}
                                                                                </select>
                                                                            </div>
                                                                        </td>
                                                                        {/* {this.state.dynamicFieldName === 'Vehicle Info' && <><td className="text-center">
                                                                            <div className="custom-checkbox">
                                                                                <input name={"chk_fieldCrewVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldCrewVisibility_" + fieldObj.field_id} checked={this.state.dynFieldsActiveItem.field_details[fieldIndex].crew_visibility} onChange={(e) => this.onHandleChange(e, fieldIndex, 'crew_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldCrewVisibility_" + fieldObj.field_id}></label>
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <div className="custom-checkbox">
                                                                                <input name={"chk_fieldClientVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldClientVisibility_" + fieldObj.field_id} checked={this.state.dynFieldsActiveItem.field_details[fieldIndex].client_visibility} onChange={(e) => this.onHandleChange(e, fieldIndex, 'client_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldClientVisibility_" + fieldObj.field_id}></label>
                                                                            </div>
                                                                        </td>
                                                                    </>} */}

                                                                        <td className="text-center">
                                                                            <div className="custom-checkbox">
                                                                                <input name={"chk_fieldMandatory_" + fieldObj.field_id} type="checkbox" id={"chk_fieldMandatory_" + fieldObj.field_id} checked={this.state.dynFieldsActiveItem.field_details[fieldIndex].is_mandatory} onChange={(e) => this.onHandleChange(e, fieldIndex, 'is_mandatory')} /> <label className="checkbox" htmlFor={"chk_fieldMandatory_" + fieldObj.field_id}></label>
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-center"><i className={DELETE_SYMBOL} title='Remove this Row' onMouseDown={(e) => this.deleteBtnClick(fieldIndex, (LBL_FIELD_NAME.toLowerCase() + ' "' + dynFieldsActiveItem.field_details[fieldIndex].field_name + '"'), this.state.dynFieldsActiveItem.field_details[fieldIndex].field_name.trim())} ></i>&nbsp;</td>
                                                                    </>}

                                                                    {/* {(dynFieldsActiveItem.field_details.length-1)===fieldIndex && <i className="fas fa-plus spanPointer" title='Add New Row' onClick={(e) => this.addNewRow(e,fieldIndex)}></i>} */}

                                                                </tr>
                                                            )  // DYNAMIC_FIELDS_TYPES 
                                                        }
                                                        )}

                                                    </tbody>
                                                </table>
                                            }
                                        </div>
                                    </div>

                                    <div className="tab-head col-12">
                                        {this.state.commonErrMsg.length > 0 && (
                                            <div className="text-red text-12 text-right">{this.state.commonErrMsg}</div>)}
                                        <div className="custom-checkbox"> &nbsp;&nbsp;&nbsp;
                                            <input type="checkbox" name={'chk_show_tab_' + dynFieldsActiveItem.id} id={'chk_show_tab_' + dynFieldsActiveItem.id}
                                                checked={this.state.dynFieldsActiveItem.show_tab ? true : false}
                                                onChange={(e) => this.onHandleChange(e, 1, 'show_tab')} /> <label className="checkbox" htmlFor={'chk_show_tab_' + dynFieldsActiveItem.id}></label><label className="labeltext" htmlFor={'chk_show_tab_' + dynFieldsActiveItem.id}>{LBL_SHOW_THIS_TAB}</label> </div>

                                        <div className="float-right">
                                            <button type="button" className="btn btn-primary saveBtnMinWidth" onClick={this.saveFormData} >{LBL_SAVE}</button>      </div>
                                        {/* <div className="divFloatRight"> </div> */}
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </Tab.Container>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>{stringFormat(LBL_ARE_YOU_SURE_DELETE_COMMON, this.state.deleteFieldName)} </ModalWindow>

                <ModalWindow ref={this.modalConfirm} header={LBL_CONFIRM_DATA_CHANGE} type="save" saveFormData={this.saveData} resetModalForm={this.onModalFormConfirmReset}> {MSG_CONFIRM_DATA_CHANGE_DYNAMIC} </ModalWindow>

                <ModalWindow ref={this.modalAdd} header={dynFieldsActiveItem.name+' - '+LBL_ADD_FIELDS} saveFormData={(e) => this.onAddFieldDetailsRows()} resetModalForm={this.onModalFormAddReset} saveButtonText={" Add "} >
                    <div className="row">
                        <table id="data-table" className='table dynTable'  >
                            <thead className="text-bold">
                                <tr>
                                    <th className="text-center ">{LBL_SELECT}</th>
                                    <th className="text-center ">{LBL_FIELD_NAME}</th>
                                    <th className="text-center ">{LBL_FIELD_TYPE}</th>
                                    <th className="text-center ">{LBL_MANDATORY_FIELD}</th>
                                    <th className="text-center "></th>
                                </tr>
                            </thead>
                            <tbody>

                                {((!addNewFieldsObj) || (!addNewFieldsObj.field_details || addNewFieldsObj.field_details.length==0)) && <tr>
                                    <td className="text-center" colSpan="5">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }

                                {addNewFieldsObj && addNewFieldsObj.field_details.map((fieldObj, index) => {
                                    return (
                                        <tr key={fieldObj.field_id}>
                                            <td className="text-center">
                                                <div className="form-group">
                                                    <div className="checkbox-wrapper">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_dynField"+index} type="checkbox" id={"chk_dynField"+index} checked={this.state.addNewFieldIds.includes(fieldObj.field_id) ? true : false} onChange={(e) => this.onSelectAddnewCheckbox(e,fieldObj.field_id)} />
                                                            <label className="checkbox" htmlFor={"chk_dynField"+index}></label>
                                                            <label className="labeltext" htmlFor={"chk_dynField"+index}>{''}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="tdVeticalMiddle">
                                                <div>{addNewFieldsObj.field_details[index].field_name}</div> </td>
                                                <td className="text-center">{this.getFieldCode(addNewFieldsObj.field_details[index].field_type)}
                                                </td>
                                                <td className="text-center">{addNewFieldsObj.field_details[index].is_mandatory ? 'Y' : 'N'}
                                                </td>
                                                <td className="text-center">&nbsp;</td>
                                        </tr>
                                    )
                                }
                                )}

                            </tbody>
                        </table>
                    </div>
                </ModalWindow>


            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        dynFieldsAllItems: state.dynamicFields.dynFieldAllItems,
        status: state.dynamicFields.status,
        activity: state.dynamicFields.activity,
        errorData: state.dynamicFields.errorData,
        dynFieldMasterItems: state.dynamicFields.dynFieldMasterItems,
        dynFieldMasterStatus: state.dynamicFields.dynFieldMasterStatus,
        dynFieldMasterActivity: state.dynamicFields.dynFieldMasterActivity,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        dynamicFieldsListAction: dynamicFieldsListAction,
        dynamicFieldsUpdateAction: dynamicFieldsUpdateAction,
        clearAction: clearAction,
        dynamicFieldsMasterListAction: dynamicFieldsMasterListAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(DynamicFieldsComponent);